var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-magnifier';
                    var viewUrl = 'gfx/sprite.svg#view-icon-magnifier';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '-1 -1 54 54',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };